import { config } from "config";


type CanonicalRule = {
  key: string;
  action: (params: URLSearchParams) => void;
};

const DEFAULT_RULES: CanonicalRule[] = [
  {
    key: "topic",
    action: (params) => {
      if (params.get("topic") === "all") {
        params.delete("topic");
      }
    },
  },
  {
    key: "removeAllParams",
    action: (params) => {
      const allowed = ["topic", "page"];
      const keys = Array.from(params.keys());
      keys.forEach((key) => {
        if (!allowed.includes(key)) {
          params.delete(key);
        }
      });
    },
  }
];

export function buildCanonicalUrl(
  asPath: string,
  pageUrl?: string,
  extraRules: CanonicalRule[] = []
): string {
  const url = new URL(pageUrl ?? asPath, config.HOST);
  const params = new URLSearchParams(url.search);

  const allRules = [...DEFAULT_RULES, ...extraRules];

  allRules.forEach((rule) => rule.action(params));

  const search = params.toString();
  return url.pathname + (search ? `?${search}` : "");
}